// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"297":"7e74ee2a","643":"bfd38d07","787":"acf9c7ba"}[chunkId] + ".chunk.js";
};